<div class="report-container">
    <p class="title">Listado Reportes</p>
    <div class="report-container-button">
        <div class="report-group">
            <input type="text" class="form-control" placeholder="Filtrar" (keyup)="filter($event)">
            <mat-icon class="blue-color">search</mat-icon>
        </div>
        <button mat-mini-fab class="green" matTooltip="Crear" matTooltipPosition="left" matTooltipClass="tooltip" (click)="edit(null)">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <table #table class="report-table" mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
            <td mat-cell *matCellDef="let item">{{item.name}}</td>
        </ng-container>
        <ng-container matColumnDef="typeQuery">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo Consulta</th>
            <td mat-cell *matCellDef="let item">{{item.typeQuery}}</td>
        </ng-container>
        <ng-container matColumnDef="storeProcedure">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Procedimiento Almacenado/URL</th>
            <td mat-cell *matCellDef="let item">{{item.storeProcedure}}</td>
        </ng-container>
        <ng-container matColumnDef="section">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Seccion</th>
            <td mat-cell *matCellDef="let item">{{item.section}}</td>
        </ng-container>
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Activo</th>
            <td mat-cell *matCellDef="let item">
                <mat-icon *ngIf="item.active" class="green-color">done</mat-icon>
                <mat-icon *ngIf="!item.active" class="red-color">clear</mat-icon>
            </td>
        </ng-container>
        <ng-container matColumnDef="Acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let item">
                <button mat-icon-button matTooltip="Eliminar" matTooltipPosition="above"
                    matTooltipClass="tooltip" (click)="delete(item.id)">
                    <mat-icon class="red-color">delete</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Editar" matTooltipPosition="above"
                    matTooltipClass="tooltip" (click)="edit(item.id)">
                    <mat-icon class="blue-color">create</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Mas" matTooltipPosition="above" matTooltipClass="tooltip" [matMenuTriggerFor]="menuUser">
                    <mat-icon class="orange-color">more_vert</mat-icon>
                </button>
                <mat-menu #menuUser="matMenu" xPosition="before">
                    <button mat-menu-item (click)="getField(item.id)">
                        <mat-icon>dns</mat-icon>
                        <span>Campos</span>
                    </button>
                    <button mat-menu-item (click)="getFilter(item.id)">
                        <mat-icon>rule</mat-icon>
                        <span>Filtros</span>
                    </button>
                    <button mat-menu-item (click)="getCountry(item.id)">
                        <mat-icon>south_america</mat-icon>
                        <span>Paises</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
    <div *ngIf="loading" class="report-container-loader">
        <div class="report-loader"></div>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 15, 20, 30, 40, 50, 100]" showFirstLastButtons></mat-paginator>
</div>